<!-- 添加、编辑集控器弹框 -->
<template>
  <el-dialog
    :title="oid == '' ? '添加' : '修改'"
    :visible.sync="modelShow"
    width="50%"
    :before-close="modelClose"
  >
    <div>
        <el-form label-width="80px" style="margin-right:40px;">
            <el-form-item label="分组名称">
                <el-input v-model="name" placeholder="请输入分组名称"></el-input>
            </el-form-item>
        </el-form>
        <p class="user-title">设置权限</p>
        <ul class="module-list">
            <li v-for="(v, i) in moduleList" :key="i">
                <span>
                    <span class="auth-name">{{v.ModuleName}}</span>
                    <span style="flex:1;">
                        <el-radio-group v-model="v.Module_value">
                            <el-radio :label="0">不可见</el-radio>
                            <el-radio :label="1">可读</el-radio>
                            <el-radio :label="2">可操作</el-radio>
                        </el-radio-group>
                    </span>
                </span>
            </li>
        </ul>
    </div>
    <div style="text-align:right;margin-top:10px;">
        <el-button type="primary" @click="handleSave">确定{{oid == '' ? '添加' : '修改'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
import { fmtArrToObj } from '@/utils/array'
export default {
    name: "cmpaddauthority",
    inject: ["reload"],
    data() {
        return {
            name: '',
            moduleList: [],
            oid: '',
        };
    },
    watch: {
        modeldata: {
            handler(newName, oldName) {
                this.initData(newName)
            },
            deep: true
        }
    },
    computed: {
        // 项目，项目列表
        ...mapGetters(['baseData', "user"])
    },
    props: {
        modelShow: Boolean,
        modeldata: Object,
    },
    created() {
    },
    methods: {
        initData(data) {
            data = JSON.parse(JSON.stringify(data));
            if(!data.oid) {
                this.oid = '';
                this.moduleList = data.moduleList.map(v=>{
                    let obj = {};
                    obj.ModuleKey = v.ModuleKey;
                    obj.Module_value = 1;   //  默认可读
                    obj.ModuleName = v.ModuleName;    
                    return obj;
                });
            }else{
                // 编辑
                this.oid = data.oid;
                this.name = data.name;
                this.moduleList = data.moduleList.filter(v=>{
                    return v.ModuleName
                })
            }
        },
        // 增加权限分组
        async AddRoleGroup(params) {
            let data = await Service.getAddRoleGroup(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                });
               this.reload();
            }
        },
        // 编辑权限分组
        async EditRoleGroup(params) {
            let data = await Service.getEditRoleGroup(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                });
               this.reload();
            }
        },
        //   关闭弹框
        modelClose() {
            // 清空表单信息
            this.$emit("update:modelShow", false);
			this.reload();
        },
        // 保存
        handleSave() {
            let data = {};
			var idx = this.name.split(" ").join("").length
            if( idx == 0 || idx >= 12 ) {
                this.$notify({
                    title: '提示',
                    message: '请输入正确的权限分组名称',
                    type: 'warning'
                });
                return
            }
            data.groupname = this.name;
            data.allowed = fmtArrToObj(this.moduleList);
			// console.log(data)
            data.enable = true; //  权限是否可用，默认可用
            if(this.oid === '') {
                data.assigned_user_id = this.user.oid;
                this.AddRoleGroup(data);
            }else{
                data.oid = this.oid;
                data.assigned_user_id = this.user.oid;
                this.EditRoleGroup(data);
            }
            
        }
    },
};
</script>
<style lang='less' scoped>
.user-title{
    margin:15px 0 15px 0;
    color: #1f2f3d;
    font-size: 16px;
}
.auth-name{
    display: inline-block;
    vertical-align: middle;
    width: 300px;
}
.module-list{
    padding: 0 20px;
    li{
        padding-left: 20px;
        line-height: 32px;
        &:nth-child(2n-1){
           background-color: #f5f7fa; 
        }
        &:hover{
            background-color: #f5f7fa;
        }
    }
}
</style>